var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"align-text-bottom"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin align-middle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }